<template>
  <div class="desktop-view">
    <MdModal data-qa-id="ai-info-modal" :isopen="show" showoverlay="true" labelledby="modal-title"
      describedby="modal-description" id="ai-info-modal" bordered="true" @handleclose="$emit('cancel')" width="554px">
      <div data-qa-id="modal-header" slot="header" class="modal-header">
        <MdTypography data-qa-id="modal-title" tag="h5" variant="heading5--medium" textalign="center">
          {{ $t('pages.aiTextEditor.ai_info_modal.title') }}
        </MdTypography>
      </div>
      <div slot="body" data-qa-id="modal-body" class="modal-body">
        <div class="info-wrapper">
          <div v-for="(item, index) in textsToRender" :key="index" class="info-row">
            <div class="info-header">
              <component :is="item.icon" width="24" height="24" />
              <MdTypography :data-qa-id="`ai-info-modal-title-${index}`" tag="p" variant="body1--medium">
                {{ item.heading }}
              </MdTypography>
            </div>
            <MdTypography :data-qa-id="`ai-info-modal-sub-title-${index}`" tag="p" variant="body1--regular">
              {{ item.subHeading }}
            </MdTypography>
          </div>
        </div>
      </div>
    </MdModal>
  </div>

  <div data-qa-id="mobile-tablet-view" class="mobile-tablet-view" v-if="show">
    <div data-qa-id="close-btn" class="close-btn" @click="$emit('cancel')">
      <MdIconClose />
    </div>
    <div class="modal-content">
      <div class="modal-header">
        <MdTypography data-qa-id="modal-title-mobile" tag="h7" variant="heading7--medium" textalign="center">
          {{ $t('pages.aiTextEditor.ai_info_modal.title') }}
        </MdTypography>
      </div>
      <div class="modal-body">
        <div class="info-wrapper">
          <div v-for="(item, index) in textsToRender" :key="index" class="info-row">
            <div class="info-header">
              <component :is="item.icon" width="16" height="16" />
              <MdTypography :data-qa-id="`ai-info-modal-title-${index}`" tag="p" variant="body2--medium">
                {{ item.heading }}
              </MdTypography>
            </div>
            <MdTypography :data-qa-id="`ai-info-modal-sub-title-${index}`" tag="p" variant="body2--regular">
              {{ item.subHeading }}
            </MdTypography>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>